import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BaseRolesService } from '../../../core/services/base-roles.service';
import { BaseErrorCodesEnum } from '../../../shared/enums/base-error-codes.enum';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { BASE_PERMISSIONS } from '../../../core/constants/base-permissions';
import { BASE_ROLES } from '../../../core/constants/base-roles';
import { BaseAvatarSize } from '../../../shared/components/avatar/base-avatar.component';
import { BaseEnvironmentService } from '../../../core/services/base-environment.service';
import { BaseApplication } from '../../../shared/enums/base-application.enum';
import { BaseExternalUrls } from '../../../shared/enums/base-external-urls.enum';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';
import { TabWithPermissionsInterface } from '../../../shared/interfaces/base-tab-with-permissions.interface';

@Component({
  selector: 'base-header',
  templateUrl: './base-header.component.html',
})
export class BaseHeaderComponent implements OnInit {
  @Input() logo: string;
  @Input() sections: BaseApplicationSectionsInterface[] = [];
  @Input() userMenu: TabWithPermissionsInterface[] = [];
  @Input() isFullscreen = false;
  buttonSizes = BaseButtonSize;
  avatarSizes = BaseAvatarSize;
  applicationSections: BaseApplicationSectionsInterface[] = [];
  isPsp = false;
  isErrorPage = false;
  stazzleLogoUrl: string;
  helpSourceUrl: string = '';

  constructor(
    private offcanvasService: NgbOffcanvas,
    private roleService: BaseRolesService,
    private environmentService: BaseEnvironmentService,
    private route: ActivatedRoute
  ) {
    this.isErrorPage = Object.values(BaseErrorCodesEnum)
      .map((val) => (isNaN(+val) ? '' : val.toString()))
      .includes(route.snapshot.routeConfig?.path || '');
  }

  ngOnInit(): void {
    this.setHelpSourceUrl();
    this.isPsp = this.roleService.isPsp();
    this.stazzleLogoUrl = this.roleService.hasWorkCouncilRole() ? '/offers' : '/dashboard';
    this.applicationSections = this.sections?.filter((option) => {
      return this.roleService.hasWorkCouncilRole()
        ? option.roleKeys.includes(BASE_ROLES.CUSTOMER_WORK_COUNCIL)
        : !option.featurePermissionKeys.length ||
            option.featurePermissionKeys.some((permission) =>
              this.roleService.hasFeaturePermission(permission as BASE_PERMISSIONS)
            );
    });
  }

  openOffcanvasSidebar(offcanvasSidebar: any, isRightSidebar: boolean = false): void {
    this.offcanvasService.open(offcanvasSidebar, {
      panelClass: 'navigation-offcanvas',
      position: isRightSidebar ? 'end' : 'start',
    });
  }

  private setHelpSourceUrl(): void {
    const application = this.environmentService.getLocalValue('application');

    switch (application.app) {
      case BaseApplication.growth:
        this.helpSourceUrl = BaseExternalUrls.HELP_PSP;
        break;
      case BaseApplication.medical:
      case BaseApplication.business:
        this.helpSourceUrl = BaseExternalUrls.HELP_CUSTOMER;
        break;
    }
  }
}
